module.exports = __webpack_public_path__ + "img/logo-illustrator.544eff8c.png";